import type { ActionHandler, ActionRegistry } from "@/types/stores/actions";
import {
  dataActions,
  fileActions,
  flowActions,
  transformActions,
} from "./dataflow/actions";
import { uiActions } from "./ui/actions";

export function createActionRegistry(): ActionRegistry {
  const registry = new Map<string, ActionHandler>();

  Object.entries(transformActions).forEach(([key, handler]) => {
    registry.set(`transform_${key}`, handler);
  });

  Object.entries(fileActions).forEach(([key, handler]) => {
    registry.set(`file_${key}`, handler);
  });

  Object.entries(dataActions).forEach(([key, handler]) => {
    registry.set(`data_${key}`, handler);
  });

  Object.entries(flowActions).forEach(([key, handler]) => {
    registry.set(`flow_${key}`, handler);
  });

  Object.entries(uiActions).forEach(([key, handler]) => {
    registry.set(`ui_${key}`, handler);
  });

  return registry;
}

export const actionMapping: Record<string, string> = {
  // General actions
  new: "file_new",
  open: "file_open",
  save: "file_save",
  export: "file_export",
  datasets: "data_datasets",
  upload: "data_upload",
  paste: "data_paste",
  run: "flow_run",
  groups: "ui_groups",
  layers: "ui_layers",
  share: "flow_share",
  expand: "ui_expand",
  report: "ui_report",
  geocode: "ui_geocode",
  enhance: "ui_enhancement",
  enhancement: "ui_enhancement",
  save_to_my_data: "ui_save",
  toggle_text_layers: "ui_toggle_text_layers",
  toggle_roads_layers: "ui_toggle_roads_layers",
  toggle_data_labels: "ui_toggle_data_labels",

  // Transform actions
  select: "transform_select",
  calculate: "transform_calculate",
  where: "transform_where",
  where_sql: "transform_where_sql",
  sort: "transform_sort",
  column_type: "transform_column_type",
  column_name: "transform_column_name",
  fill_missing: "transform_fill_missing",
  find_replace: "transform_find_replace",
  upper_lower: "transform_upper_lower",
  join: "transform_join",
  group: "transform_group",

  // View actions
  map: "view_change",
  table: "view_change",
  json: "view_change",
  diagram: "view_change",

  // Layer actions
  chart: "view_change",
  flow: "view_change",
  make: "view_change",
};
